import api from '@/store/api';
import { atlas } from '@/store/api/instances';
import type { ApiResponse } from '@bitstopco/bitstop-theme';

export interface Platform {
  id: string;
  key: string;
  name: string;
}

export const platformsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPlatforms: build.query<ApiResponse<Platform[]>, void>({
      query: () =>
        atlas({
          url: '/v2/platforms',
          method: 'GET',
        }),
    }),
  }),
});

export const { useGetPlatformsQuery } = platformsApi;
